<template>
  <naj-box
    :title="local.contact.title"
    :collapsed="!isMobileRequired"
    :no-bottom-margin="noBottomMargin"
    :no-h-gutters="noHGutters"
  >
    <v-row>
      <v-col
        cols="12"
        :lg="cols || 3"
      >
        <naj-input
          v-mask="'05########'"
          :type-id="formFieldType.text"
          :label="local.contact.mobile"
          :value.sync="formModel.mobile"
          :validates="`${isMobileRequired ? 'required' : ''}|digits:10`"
          :disabled="isViewMode"
        ></naj-input>
      </v-col>
      <!--<v-col cols="12" :lg="cols || 3">
        <naj-input
          :type-id="formFieldType.text"
          :label="local.contact.workPhone"
          :value.sync="formModel.workPhone"
          validates="digits:10"
          v-mask="'##########'"
        ></naj-input>
      </v-col>
      <v-col cols="12" :lg="cols || 3">
        <naj-input
          :type-id="formFieldType.text"
          :label="local.contact.homePhone"
          :value.sync="formModel.homePhone"
          validates="digits:10"
          v-mask="'##########'"
        ></naj-input>
      </v-col>
      <v-col cols="12" :lg="cols || 3">
        <naj-input
          :type-id="formFieldType.text"
          :label="local.contact.fax"
          :value.sync="formModel.fax"
          validates="digits:10"
          v-mask="'##########'"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row> -->
      <v-col
        cols="12"
        :lg="cols || 3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.contact.email"
          :value.sync="formModel.email"
          validates="email|no_gov_email"
          :disabled="isViewMode"
        ></naj-input>
      </v-col>
    </v-row>
  </naj-box>
</template>

<script>
export default {
  inject: ['$validator'],
  props: ['formModel', 'required', 'mobileRequired', 'noBottomMargin', 'noHGutters', 'cols', 'isViewMode'],
  computed: {
    isMobileRequired() {
      return this.required || this.mobileRequired;
    },
  },
};
</script>
